import React from 'react'
import iconsquare from '../../assets/images/icon-square.png'
import Header from '../../header'
import axios from 'axios';
import config from '../../config'
import { v4 as uuidv4 } from 'uuid';
class Graphics extends React.Component{
    constructor(props)
    {
        super(props)
        {
            this.state={
                data:[],
                graphics:[],
                selectedItems:JSON.parse(sessionStorage.getItem('graphics')),
                graphicsloader : false,
                count : 1
            }
        }
        this.graphicsback = this.graphicsback.bind(this)
        this.graphicsnext = this.graphicsnext.bind(this)
        this.selectgraphics = this.selectgraphics.bind(this);
    }
    graphicsback()
    {
        this.props.history.push('/designs');
    }
    graphicsnext()
    {
        this.props.history.push('/alphabets');
    }
    selectgraphics(id,src,index, value)
    {
        const {selectedItems } = this.state;
        if(value == 1)
        {
        selectedItems.push({
            id:id,
            graphicsid : uuidv4(),
            img:src
        })
          this.setState({
              tempstate:selectedItems
          })
          const filtered = selectedItems.filter(el => {
            return el != null && el != '';
          });
          sessionStorage.setItem('graphics',JSON.stringify(filtered));
        }
        else{
            let i=0;
            for(i= 0; i <= selectedItems.length;i++)
            {
                if(selectedItems[i])
                {
                    if(selectedItems[i].id == id)
                    {
                        delete selectedItems[i];
                        break;
                    }
                }
            }
            var filtered = selectedItems.filter(function (el) {
                return el != null;
            });
            this.setState({
                tempstate:selectedItems
            })
            sessionStorage.setItem('graphics',JSON.stringify(filtered));
        }
    }
    componentDidMount()
    {
        this.setState({
            graphicsloader : true
        })
        let store_id = sessionStorage.getItem('store_id');
        let apiDynamicUrlAddress = config.default.api.host;
        let apiUrl = `${apiDynamicUrlAddress}getAssests?type=graphics&store_id=${store_id}`
        axios.get(apiUrl , {
            crossDomain : true,
            enablePreflight : false
        }).then((response) => {
           if(response.data.success == 1)
            {
                this.setState({
                    graphicsloader : false
                })
                this.setState({data:response.data.data})
            }
        })
        .catch((err) => {

        });
    }
    render()
    {
        const {selectedItems,graphicsloader, count} = this.state;
        return(
            <div>
                <Header/>
                <section className="home-register-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <div className="home-register-form-div design-menu-sec design-logo-sec">
                                    <div className="form-logo-section sec-center">
                                        <a href="#/register"><img src={iconsquare} alt="logo" className="img-fluid brand-logo"/></a>
                                    </div>
                                    <h3>Designs</h3>
                                    <h4>Graphics</h4>
                                    {graphicsloader ? 
                                    <div class="spinner-border logo" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    :
                                    <div>
                                        <div className="col-md-12 sec-center left">
	                                        <div className="design-logo-grid-outer design-graphics-grid-outer">
                                                <div className="design-logo-grid-inner">
                                                {this.state.data && this.state.data.map((item, index)=>{
                                                    return(
	                                                    <div key={index} className="logo-grid-box">
	                                                        <div className={selectedItems.filter(x=>x.id==item.id).length > 0 ? "logo-grid-box-img active" : "logo-grid-box-img"}>
	                                                            <img id={item.id} src={item.image_path} alt="logo1" className="img-fluid"/>
	                                                        </div>
	                                                        <div className="logo-grid-box-content">
                                                                <h5>graphic {count + index}</h5>
	                                                        </div>
                                                        <ul>
                                                            <li><button disabled={selectedItems.filter(x=>x.id==item.id).length == 0} onClick={(e) => this.selectgraphics(item.id,item.image_path,'-1')}>-</button></li>
                                                            <li>{selectedItems.filter(x=>x.id==item.id).length}</li>
                                                            <li><button disabled={selectedItems.filter(x=>x.id==item.id).length == 5} onClick={(e) => this.selectgraphics(item.id,item.image_path,index,'1')}>+</button></li>
                                                        </ul>
	                                                </div>
                                                    )
                                                })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    <div className="col-md-12 sec-center left">
                                        <div className="footer-btn"> 
                                            <div className="footer-left-btn"> 
                                                <button onClick={this.graphicsback} className="black_btn">Back</button>
                                            </div>
                                            <div className="footer-right-btn"> 
                                                <button onClick={this.graphicsnext} className="black_btn">Next</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
export default Graphics;